import React, { useEffect } from "react"
import StickerDropzone from "./StickerDropzone"
import * as StickerUtil from "../../utils/StickerUtil"
import MediaContainer from "../common/MediaContainer"

interface EditImagePreviewProps {
  userImage: string
  currentOverlayUrl: string | null
  currentBackgroundUrl: string | null
}

export default function EditImagePreview({
  userImage,
  currentOverlayUrl,
  currentBackgroundUrl,
}: EditImagePreviewProps) {
  useEffect(() => {
    document.onmouseup = StickerUtil.onMouseUp
    document.ontouchcancel = StickerUtil.onMouseUp
    document.ontouchend = StickerUtil.onMouseUp

    return () => {
      document.onmouseup = null
      document.ontouchcancel = null
      document.ontouchend = null
    }
  }, [])

  const fullImageProps = {
    width: "100%",
    height: "100%",
  }
  return (
    <MediaContainer>
      <StickerDropzone />

      {currentOverlayUrl !== null && (
        <img
          id="overlayImage"
          crossOrigin="anonymous"
          src={currentOverlayUrl}
          alt="Overlay"
          {...fullImageProps}
        />
      )}

      {userImage && (
        <img
          id="userImage"
          crossOrigin="anonymous"
          src={userImage}
          alt="Preview"
          {...fullImageProps}
        />
      )}

      {currentBackgroundUrl != null && (
        <img
          id="selectedBackground"
          crossOrigin="anonymous"
          src={currentBackgroundUrl}
          alt="Background"
          {...fullImageProps}
        />
      )}
    </MediaContainer>
  )
}
